import React from 'react';

import Conversations from './conversations';
import ChatMessages from './chat-messages';

import styles from './Chat.css';

const Chat = () => (
  <div className={styles.heroContainer}>
    <Conversations />
    <ChatMessages />
  </div>
)

export default Chat;


// WEBPACK FOOTER //
// ./src/pages/chat/Chat.jsx